<template>
  <TabGroup>
    <TabList class="lg:space-x-8 md:space-x-4 space-x-0 rtl:space-x-reverse py-4 ps-2 sm:sticky sm:top-[59px] md:top-[82px] sm:z-[99] bg-white dark:bg-slate-800 border rounded-xl border-dashed border-slate-200 dark:border-slate-500">
      <Tab
          v-slot="{ selected }"
          as="template"
          v-for="(item, i) in [
            {
              title: $t('message.basic information'),
              icon: 'heroicons-outline:user',
            },
            {
              title: $t('menuItems.kyc'),
              icon: 'ci:user-check',
            },
            {
              title: $t('message.took orders'),
              icon: 'fluent:apps-list-detail-24-regular',
            },
          ]"
          :key="i">
        <button
            :class="[
            selected
              ? 'text-primary-500 before:w-full'
              : 'text-slate-500 before:w-0 dark:text-slate-300',
          ]"
            class="inline-flex items-start text-sm font-medium my-2 capitalize bg-white dark:bg-slate-800 ring-0 foucs:ring-0 focus:outline-none px-2 transition duration-150 before:transition-all before:duration-150 relative before:absolute before:left-1/2 before:bottom-[-6px] before:h-[1.5px] before:bg-primary-500 before:-translate-x-1/2"
        >
          <span class="text-base relative top-[1px] ltr:mr-1 rtl:ml-1"
          ><Icon :icon="item.icon"/></span
          >{{ item.title }}
        </button>
      </Tab>
    </TabList>
    <TabPanels>
      <TabPanel>
        <div class="text-slate-600 dark:text-slate-400 text-sm font-normal">
          <basic-information :applicantBasicInformation="applicantBasicInformation"/>
        </div>
      </TabPanel>
      <TabPanel>
        <div class="text-slate-600 dark:text-slate-400 text-sm font-normal">
          <KYC/>
        </div>
      </TabPanel>
      <TabPanel>
        <div class="text-slate-600 dark:text-slate-400 text-sm font-normal">
          <TookOrders/>
        </div>
      </TabPanel>
    </TabPanels>
  </TabGroup>
</template>

<script>
import {TabGroup, TabList, Tab, TabPanels, TabPanel} from "@headlessui/vue";
import Icon from "@/components/Icon/index.vue";
import TookOrders from "@/views/manageApplicants/boost/applicantDetails/tabs/tookOrders/index.vue";
import BasicInformation from "@/views/manageApplicants/boost/applicantDetails/tabs/basicInformation.vue";
import KYC from "@/views/manageApplicants/boost/applicantDetails/tabs/KYC.vue";
import window from "@/mixins/window";

export default {
  mixins: [window],
  components: {
    TabGroup,
    TabList,
    Tab,
    TabPanels,
    TabPanel,
    Icon,
    TookOrders,
    BasicInformation,
    KYC
  },
  props: {
    applicantBasicInformation: {
      type: Object,
    },
  },
}
</script>
